module.exports = __webpack_public_path__ + "img/IMG_0277.f305eb33.png";